namespace TabAurous.OMS {
    export namespace PromotionDetailsService {
        export const baseUrl = 'OMS/PromotionDetails';

        export declare function Create(request: Serenity.SaveRequest<PromotionDetailsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PromotionDetailsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PromotionDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PromotionDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetPromotions(request: RetailRequest, onSuccess?: (response: Serenity.ListResponse<PromotionDetailsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/PromotionDetails/Create",
            Update = "OMS/PromotionDetails/Update",
            Delete = "OMS/PromotionDetails/Delete",
            Retrieve = "OMS/PromotionDetails/Retrieve",
            List = "OMS/PromotionDetails/List",
            GetPromotions = "OMS/PromotionDetails/GetPromotions"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetPromotions'
        ].forEach(x => {
            (<any>PromotionDetailsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
